module.exports = __webpack_public_path__ + "files/905a4b1906c2694a2374b115bd7aa731.png";